/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
const E = "d", F = "wide", L = (A, o, s) => A === null || !(o && o > A || s && s < A);
export {
  E as DEFAULT_FORMAT,
  F as DEFAULT_FORMAT_PLACEHOLDER,
  L as isInRange
};
